
// Purpose: Holds static auth-related constants used throughout the codebase.

export const PROTECTED_ROUTES = [
  '/dashboard',
  '/profile',
  '/admin',
  '/messages',
  '/contracts',
  '/address-change',
  '/damage-report'
];
